import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { PositioningSection } from './components/PositioningSection';
import { ModulesSection } from './components/ModulesSection';
import { ProgressionSection } from './components/ProgressionSection';
import { DifferentiationSection } from './components/DifferentiationSection';
import { SkoolSection } from './components/SkoolSection';
import { WhoIsForSection } from './components/WhoIsForSection';
import { WhoIsNotForSection } from './components/WhoIsNotForSection';
import { FinalCtaSection } from './components/FinalCtaSection';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '1688823188448978';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window === 'undefined') return;
    if (!window.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (document.head || document.body || document.documentElement).appendChild(script);
      window.fbq('init', META_PIXEL_ID);
    }
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <PositioningSection data-id="element-5" />
      <ModulesSection data-id="element-6" />
      <ProgressionSection data-id="element-7" />
      <DifferentiationSection data-id="element-8" />
      <SkoolSection data-id="element-9" />
      <WhoIsForSection data-id="element-10" />
      <WhoIsNotForSection data-id="element-11" />
      <FinalCtaSection data-id="element-12" />
    </div>;
}